export default "__VITE_ASSET___D6jxkQr__"